module.exports = __webpack_public_path__ + "img/Coins.b32c5b12.gif";